module.exports = __webpack_public_path__ + "static/media/greg-profile.205dcdc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/OnboardingHiImGreg/assets/greg-profile.png
// module id = 1274
// module chunks = 0